import { connect } from 'react-redux';
import {
  actionGetVoucherDetail,
  actionCreateVoucherCampaign,
  actionUpdateVoucherCampaign,
  actionAddCodeToVoucher,
  actionClearVoucherDetail,
  actionDeleteVouchersFromCampaign,
} from 'store/voucher/actions';

import ManagerVoucherCampaign from './ManagerVoucherCampaign';

const mapStateToProps = (state) => ({
  isLoadingCampaignDetail: state.Voucher.isLoadingGetVoucherDetail,
  isSubmittingCampaign:
    state.Voucher.isLoadingCreateVoucherCampaign ||
    state.Voucher.isLoadingUpdateVoucherCampaign,
  isAddingVoucherCodes: state.Voucher.isLoadingAddCode,
  isDeletingVouchers: state.Voucher.isLoadingDeleteVouchers,
  voucherDetail: state.Voucher.voucherDetail,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetVoucherDetail: (payload) =>
    dispatch(actionGetVoucherDetail(payload)),
  actionCreateVoucherCampaign: (payload) =>
    dispatch(actionCreateVoucherCampaign(payload)),
  actionUpdateVoucherCampaign: (payload) =>
    dispatch(actionUpdateVoucherCampaign(payload)),
  actionAddCodeToVoucher: (payload) =>
    dispatch(actionAddCodeToVoucher(payload)),
  actionClearVoucherDetail: () => dispatch(actionClearVoucherDetail()),
  actionDeleteVouchersFromCampaign: (payload) =>
    dispatch(actionDeleteVouchersFromCampaign(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ManagerVoucherCampaign);
